export default {
  noSamePass: 'Las contraseñas no coinciden',
  loginSuccess: 'Inicio de sesión exitoso',
  registerSuccess: 'Registro exitoso',
  isHaveAccount: '¿Ya tienes una cuenta?',
  login: 'Iniciar sesión',
  logout: 'Cerrar sesión',
  forgetPass: '¿Olvidaste tu contraseña?',
  register: 'Registrarse',
  registered: 'Ya estás registrado,',
  emailTips: 'Correo electrónico',
  password: 'Contraseña',
  pwdErr: 'Contraseña incorrecta.',
  confirmPass: 'Confirmar contraseña',
  countryTips: 'Selecciona tu país',
  inviteCodeTips: 'Ingresa el código de invitación (opcional)',
  verifyEmpty: 'La información de entrada no puede estar vacía',
  verifyEmail: 'Por favor, introduzca el formato de correo electrónico correcto',
  verifyPass: 'La contraseña debe tener entre 6 y 20 caracteres y debe contener letras y números',
  confirmText: 'He leído y acepto',
  verifyCode: 'Código de verificación',
  loginPwd: 'Contraseña de inicio de sesión',
  editPwd: 'Modificar contraseña',
  changePwd: 'Cambiar contraseña de inicio de sesión',
  setPwd: 'Establecer contraseña',
  and: 'y',
  privacyStatement: '《Declaración de privacidad》',
  confirm: 'Confirmar',
  cancel: 'Cancelar',
  editSuccess: 'Modificado exitosamente',
  email: 'Correo electrónico',
  emailCode: 'Verificación de correo electrónico',
  newPwd: 'Nueva contraseña',
  button: {
    search: 'Buscar',
    query: 'VER AHORA',
    reset: 'Restablecer',
    submit: 'Enviar',
    submitOrder: 'Enviar pedido',
    save: 'Guardar',
  },
  holder: {
    select: 'por favor seleccione',
    startTime: 'Hora de inicio',
    endTime: 'Hora de finalización',
    max: 'máximo',
    min: 'mínimo',
    inputContent: 'Por favor ingrese el contenido',
    inputEmailAccount: 'Por favor ingrese la cuenta de correo electrónico correcta',
  },
  back: '¡Bienvenido de nuevo!',
  continueGoogle: 'Continuar con Google',
  notAccount: '¿No tienes una cuenta?',
  signNow: 'Regístrate ahora',
  termService: 'Términos de servicio',
  privacyPolicy: 'Política de privacidad',
  helpCenter: 'Centro de ayuda',
  readPrivacy: 'Ya he leído y acepto',
  verifyAccept: 'no has leído el acuerdo',
  accountSecurity: 'Seguridad de la cuenta',
  loginNow: 'Iniciar sesión ahora',
  resetPsd: 'Restablecer contraseña',
  verifiedEmail: 'Verificar correo electrónico',
  verifyUrl: 'Por favor, introduzca el formato de URL correcto',
  unverified: 'no verificado',
  emailVerification: 'Verificación de correo electrónico',
  verifyMsg:
    'Tu correo electrónico no ha sido verificado, por lo que temporalmente no podemos completar la operación de compra. Por favor, verifica tu correo electrónico en el centro personal.',
  sendVerificationEmail: 'Enviar correo de verificación',
  linkHasExpired: '¡El enlace ha expirado!',
  hasSendEmail: 'Se ha enviado el correo de verificación',
  shippingFeeEstimation: 'Estimación de gastos de envío',
  homeText: 'Página principal',
  loginBgMsg: 'Únete a Discord de acbuy para obtener más beneficios',
  registerTitleMsg: 'COMENZA TU VIAJE',
  registerBgMsg: 'Los nuevos registrados reciben {coupon}+ cupones de envío',
  announcement: 'Anuncio',
  formAnnouncementMsg:
    'Un nuevo modelo para el programa de afiliados, modelo de comisión de doble paquete, úsalo para ganar dinero y ahorrar',
  incorrectAmount: 'El monto de retiro debe ser mayor que 0',
  readPrivacy1: 'He leído',
  andAgree: 'y aceptado',
  aboveContent: 'el contenido anterior',
  purchasingNotice: 'Aviso de compra',
  afterSaleService: 'servicio postventa',
  uniOrderAgreeText:
    'El enlace que has enviado en esta página pertenece a enlaces de productos de terceros (como Xianyu, Xiaohongshu, Bilibili, etc.), y acbuy solo puede ayudarte a encontrar al comerciante del enlace para consultar el producto, comprarlo y organizar los servicios de entrega logística de terceros. acbuy no puede distinguir entre la calidad y la autenticidad del producto, y debes asumir los riesgos relacionados antes de realizar el pedido.',
  excludeFees: 'Aviso importante: los gastos de envío internacional se calcularán por separado.',
  selectProductBtn: 'Elija el producto de mi Almacén',
}
